export default __webpack_public_path__ + "static/media/image4.2d0bcb15.png";